import {Utils} from "../Modules/Utils";

Utils.executeWhenDocumentIsReady(  () => {
    const links = document.querySelectorAll(
        'a[href*="#"]:not([href="#"]):not(.c-accordion__header):not(.c-linkbox__header)',
    )

    links.forEach((link) => {
        // @ts-ignore
        if(link.origin + link.pathname == self.location.href) {
            link.addEventListener("click", (event: Event) => {
                event.preventDefault()
                const targetHash = (link as HTMLAnchorElement).hash
                const target = document.querySelector(targetHash)

                if (target) {
                    const targetOffsetTop =
                        target.getBoundingClientRect().top + window.scrollY
                    const scrollToPosition = targetOffsetTop - 100

                    window.scrollTo({
                        top: scrollToPosition,
                        behavior: "smooth",
                    })
                }
            })
        }
    })
})